import { UserListItemProps, TabsContent } from '@app/shared/ui/molecules/Friends';
import { UserList } from './';
import { LeaderboardTypeFilter } from '@app/store/slices/friends/friendsTypes';
import { cn } from '@app/shared/utils/common';

interface XPTabProps {
  users: UserListItemProps[];
  isUsersLoading: boolean;
}

export function XPTab({ users, isUsersLoading }: XPTabProps) {
  return (
    <TabsContent value={LeaderboardTypeFilter.XP}>
      <UserList
        users={users}
        isUsersLoading={isUsersLoading}
        className={cn('h-full overflow-auto', 'scrollbar-hide')}
      />
    </TabsContent>
  );
}
